import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=06b3be60"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports